import { apiCaller } from '@/api/apiCaller';
import { apihost } from '@/api/urls';

const getAll = () => apiCaller.get('/clientcontract/', apihost);

export const clientContractApi = {
    getAll,
};
